import Stage from './Stage.js';
import React from 'react';

export default class Beira {
  constructor() {
    this.stages = 
    [
      // Beira
      new Stage(
        [[-150, 85], [160, -65]], //Global
        (<div className="layout-timeline-info layout-floating">
          <h4>Global Flood Risks</h4>
          <span>Between 150–250 M people currently occupy land below projected high tide lines for 2100 under low 
            carbon emissions <a href="https://www.nature.com/articles/s41467-019-12808-z" target="_blank" rel="noopener noreferrer">[1]</a>.
            <br/><br/>
            Global population is rapidly urbanizing, with 68% of the world population projected to live in urban 
            areas by 2050 <a href="https://population.un.org/wup/Publications/Files/WUP2018-Report.pdf"  target="_blank" rel="noopener noreferrer">[2]</a>.
            <br/><br/>
            The intersection of these two trends illuminates the need for tools that can highlight populations at 
            risk before a flooding event occurs.
            </span>
        </div>),
        (<div className='layout-legend-hidden'></div>),
        "Global Flood Risks"
      ),
      new Stage(
        [[34.7011, -19.7022], [35.0444, -19.9241]],
        (<div className="layout-timeline-info layout-floating">
          <h4>About Beira</h4>
          <span>Beira is the capital and largest city of Sofala Province in Mozambique. Beira is located where 
            the Pungwe River meets the Indian ocean, in the central region of Mozambique. It is home to more than 
            530,000 people.</span>
        </div>),
        (<div className='layout-legend-hidden'></div>),
        "Beira"
      ),
      new Stage(
        [[34.8070, -19.7535], [34.9375, -19.8699]],
        (<div className="layout-timeline-info layout-floating"><h4>Structures</h4>
        <span>Planet’s global building mapping <a href="https://www.planet.com/products/analytics/" target="_blank" rel="noopener noreferrer">product</a> isolates 
        structures from satellite imagery, and can be used to unlock new insights about the region.</span></div>),
        (<div className='layout-legend-hidden'></div>),
        "Beira - Structures"
      ),
      new Stage(
        [[34.8070, -19.7535], [34.9375, -19.8699]],
        (<div className="layout-timeline-info layout-floating"><h4>Flood frequency</h4>
        <span>Cloud to Street&apos;s flood frequency <a href="https://www.cloudtostreet.info/methods" target="_blank" rel="noopener noreferrer">product</a>{' '}
        detects and analyzes all flood observations for each pixel over 
        the past 34 years to identify where high frequency flooding is likely to occur in the near future. A 
        scientific comparison of this satellite based method to traditional flood modeling shows that satellites are 
        more effective than models at identifying high-return period floods, at least for locations with poor ground data like Beira. 
        <br/><br/>
        To see more flood maps and impact statistics for Beira see:{' '}
        <a href="https://mozambique-flood-monitoring.cloudtostreet.info/recent-data"  target="_blank" rel="noopener noreferrer">mozambique-flood-monitoring.cloudtostreet.info</a>{' '}
        (displayed as if today is the 2019 Cyclone emergency).</span></div>),
        (<div className='layout-legend-visible layout-timeline-legend layout-floating'>
          <div className="pl-ctrl-legend">
            <div className="pl-ctrl-legend-min">Low</div>
            <div className="pl-ctrl-legend-levels">
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(239, 243, 255)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(189, 215, 231)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(107, 174, 214)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(33, 113, 181)', 'width': '30px'}}></div>
            </div>
            <div className="pl-ctrl-legend-max">High</div>
          </div>
        </div>),
        "Beira - Flood Frequency"
      ),
      new Stage(
        [[34.8401, -19.7778], [34.9260, -19.8720]],
        (<div className="layout-timeline-info layout-floating"><h4>Structures at Risk of Flood</h4>
        <span>
          Combining these datasets allows us to visually and spatially identify buildings at risk from flooding.
          <p />
          From this, we can calculate that <b>37.8%</b> of the area in which floods have historically been observed in Beira now contain structures.
        </span></div>),
        (<div className='layout-legend-visible layout-timeline-legend layout-floating'>
          <div className="pl-ctrl-legend">
            <div className="pl-ctrl-legend-min">Low</div>
            <div className="pl-ctrl-legend-levels">
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(254, 237, 222)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(253, 190, 133)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(253, 141, 60)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(217, 71, 1)', 'width': '30px'}}></div>
            </div>
            <div className="pl-ctrl-legend-max">High</div>
          </div>
        </div>),
        "Beira - Structures at risk of flood"
      ),
      new Stage( //ss-flood
        [[34.8327, -19.8131], [34.9030, -19.8511]],
        (<div className="layout-timeline-info layout-floating">
          <h4>The foundation of climate risk financing for vulnerable cities</h4>
          <span>Climate financing cannot be built before there are technical instruments to assess and monitor risk 
            over time. The second requirement is an objective and reliable instrument to detect and trigger funds 
            during disasters. This flood map of the Idai cyclone in March 2019 shows which assets were impacted via one SkySat 
            satellite.   
            <br/><br/>
            This visualization is the very beginning of a collaborative tool that the organizations are developing 
            together for risk financing.</span>
        </div>),
        (<div className='layout-legend-hidden'></div>),
        "Beira - Historical Flood"
      ),

    ]
  }
  getStages() {
    return this.stages;
  }
}